import { render, staticRenderFns } from "./create-patient-service.vue?vue&type=template&id=200037ca&"
import script from "./create-patient-service.vue?vue&type=script&lang=js&"
export * from "./create-patient-service.vue?vue&type=script&lang=js&"
import style0 from "./create-patient-service.vue?vue&type=style&index=0&id=200037ca&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports